export default __webpack_public_path__ + "static/media/icon-edit.a519aff2.svg";